// extracted by mini-css-extract-plugin
export default {"root":"FiNNH4LH4A3W1XoHj81I","active":"wCpZRxJpOmnPewMkv4l7","placeHolderShimmer":"QtNo72PlqqIAM5xjODzW"};